module.exports = "https://images.shiksha.ws/saassets/media/Footer-sprite.bf138345.svg";